import * as React from 'react';
import { NegotiationState } from '../../generated/graphql';

export const NegotiationTestOverrideContext = React.createContext({
  negTestOverrideActive: false,

  negStateTest: NegotiationState.ConfirmedByUser as NegotiationState,
  setNegStateTest: ((() => {}) as React.Dispatch<React.SetStateAction<NegotiationState>>),

  prePaymentTest: 0,
  setPrePaymentTest: ((() => {}) as React.Dispatch<React.SetStateAction<number>>),
});

export const useNegotiationTestOverrideContext = () => React
  .useContext(NegotiationTestOverrideContext);

type NegotiationTestOverrideContextProps = { negTestOverrideActive?: boolean };
export const NegotiationStateOverrideContextProvider:
React.FC<NegotiationTestOverrideContextProps> = (props) => {
  const { children, negTestOverrideActive = false } = props;
  const [ negStateTest, setNegStateTest ] = React.useState(NegotiationState.ConfirmedByUser);
  const [ prePaymentTest, setPrePaymentTest ] = React.useState(0);

  return (
    <NegotiationTestOverrideContext.Provider value={{
      negTestOverrideActive,
      negStateTest,
      setNegStateTest,
      prePaymentTest,
      setPrePaymentTest,
    }}
    >
      {children}
    </NegotiationTestOverrideContext.Provider>
  );
};
